import { themeColours } from "./themeColours";

// ag-grid is styled via CSS custom properties (styles/ag-grid-edb_custom.css), a completely
// separate mechanism from Chakra's theme/semanticTokens - a colour value can't be shared between
// a .ts object and a .css file automatically. This closes that gap at runtime instead: copy
// themeColours' ag-grid-prefixed values onto document.documentElement as real CSS custom
// properties once at app startup (called from main.tsx), so themeColours.ts stays the ONE file
// you edit for every colour in the app, ag-grid included. Values set via element.style.setProperty
// on :root take precedence over anything in an imported stylesheet regardless of import order
// (inline style beats stylesheet), so this is guaranteed to win.
//
// ag-grid-edb_custom.css references these same --edb-* custom property names via var(...,
// fallback) - the fallback keeps the grid looking correct even if this function is ever removed
// or fails to run, it just stops being editable from one place.
//
// Takes an optional colours object (defaults to the real themeColours) so ThemeEditor's live
// preview (applyLiveThemeOverride.ts) can reuse this exact function with edited-but-not-yet-saved
// values instead of duplicating the property-name list.
export function applyAgGridColours(colours: typeof themeColours = themeColours) {
  const root = document.documentElement;
  root.style.setProperty("--edb-ag-container-bg", colours.agGridContainerBackground);
  root.style.setProperty("--edb-ag-internal-bg", colours.agGridInternalBackground);
  root.style.setProperty("--edb-ag-headerbar-bg", colours.agGridHeaderBar);
  root.style.setProperty("--edb-ag-groupingbar-bg", colours.agGridGroupingBar);
  root.style.setProperty("--edb-ag-filterbar-bg", colours.agGridFilterBar);
}
